module.exports = __webpack_public_path__ + "signUp-djd.png";